import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { TelephoneFill } from "react-bootstrap-icons";
import "./ourservices.scss";

function DemoCall() {
   const phoneNumber = "+919158926281"; // Change to your number

  return (
    <section className="demo-call-section py-5 text-white">
  <Container>
    <Row className="align-items-center">

      <Col lg={8}>
        <h2 className="fw-bold">
          Ready to Experience Our Software in Action?
        </h2>
        <p className="mt-3">
          Contact our team today to schedule a live demo or get technical support.
        </p>
      </Col>

      <Col lg={4} className="text-lg-end mt-4 mt-lg-0">
        <Button
          href={`tel:${phoneNumber}`}
          size="lg"
          className="me-3 px-4"
          variant="light"
        >
          Call Now
        </Button>

        <Button
          href="https://wa.me/919158926281"
          target="_blank"
          rel="noopener noreferrer"
          size="lg"
          variant="success"
          className="px-4"
        >
          WhatsApp
        </Button>
      </Col>

    </Row>
  </Container>
</section>
  );
}

export default DemoCall;

